module.exports = "/_next/static/images/fingerprint-uv-c7c49f4ee2e5c47daf687c5ed1803b4d.png";